import { type FragmentType, getFragmentData, graphql } from '../../../__generated__'
import { SentContent } from '../../../Components/SentContent/SentContent'
import { SchoolSentCollapse } from './SchoolSentCollapse'

const fragments = {
  ReportSentUnregisteredSchool_publicReportSource: graphql(`
    fragment ReportSentUnregisteredSchool_publicReportSource on PublicReportSource {
      id
      sourceType
    }
  `),
}

type Props = {
  channel: FragmentType<typeof fragments.ReportSentUnregisteredSchool_publicReportSource>
}
export const ReportSentUnregisteredSchool = ({ channel: _channel }: Props) => {
  const channel = getFragmentData(
    fragments.ReportSentUnregisteredSchool_publicReportSource,
    _channel
  )

  return (
    <SentContent
      sourceType={channel.sourceType}
      description={
        <>
          Bohužel, tvoje škola není ve FaceUpu zaregistrována. Nemůžeme tedy zaručit, že se budou
          upozorněním zabývat. Zkusíme se s nimi ale spojit, aby se mu věnovat začali.
        </>
      }
    >
      <SchoolSentCollapse />
    </SentContent>
  )
}
